import {Component, EventEmitter, OnDestroy, Output} from '@angular/core';
import {OktaService} from '../../shared/_services/okta.service';
import {Subject, timer} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss']
})

export class IntroComponent implements OnDestroy {

  @Output() public introDone = new EventEmitter<boolean>();

  userReceived = false;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private oktaService: OktaService,
  ) {
    this.onUserInfo();
    this.onOktaError();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private onUserInfo(): void {
    this.oktaService.onNewUserInfo()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (user) => {
          if (user) {
            this.userReceived = true;
            timer(800)
              .pipe(takeUntil(this.onDestroy$))
              .subscribe(() => {
                this.introDone.emit(true);
              });
          }
        }
      );
  }

  private onOktaError(): void {
    this.oktaService.onNewOktaError()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (error) => {
          if (error) {
            this.introDone.emit(true);
          }
        }
      );
  }

}
